import { useProfile } from '@entities/profile/model/store/profile.store'
import { Link } from '@tanstack/react-router'
import cn from 'classnames'
import { Fragment, ReactNode, memo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { LogoEducation } from '@components/logo/logo-education'
import { LogoProject } from '@components/logo/logo-project'
import { LogoSupport } from '@components/logo/logo-support'
import { Title } from '@components/title/title'

import { config } from '@shared/config'
import styles from './profile-preview.module.css'

type ProfilePreviewProps = {
  className?: string
  ThemeSlot: ReactNode
  SelectCitySlot: ReactNode
  ChangeSlot: ReactNode
  SignoutSlot: ReactNode
}

export const ProfilePreview = memo(
  ({
    className,
    ThemeSlot,
    SelectCitySlot,
    ChangeSlot,
    SignoutSlot
  }: ProfilePreviewProps): JSX.Element => {
    const { t } = useTranslation('main')
    const { t: planT } = useTranslation('plan')
    const { profile } = useProfile()

    const currentUserName = profile?.userName || 'Guest'
    const daysLeft = profile?.subDays ?? 0

    const [isCollapsed, setIsCollapsed] = useState<boolean>(true)
    const logoCls = cn(styles.logo, className, {
      [styles.collapsed]: isCollapsed === true
    })

    return (
      <Fragment>
        <LogoProject
          className={logoCls}
          colored={isCollapsed}
          onClick={() => setIsCollapsed((prev) => !prev)}
        />
        <div
          className={cn(styles.container, {
            [styles.collapsed]: isCollapsed === true
          })}
        >
          <div className={styles.header}>
            <Title>{currentUserName}</Title>
            <div className={styles.actions}>{ThemeSlot}</div>
          </div>
          {SelectCitySlot}
          <Link to={'/education'} className={styles.link}>
            <LogoEducation size="md" type="accent" />
            {t('menu.education')}
          </Link>
          <a
            href={config.getTgBotSupportUrl()}
            target="_blank"
            rel="noreferrer"
            className={styles.link}
          >
            <LogoSupport size="md" type="accent" />
            {t('menu.support')}
          </a>
          {/* {CollectionSlot} */}
          <div className={styles.body}>
            <div className={styles.subscription}>
              <span className={styles.subscriptionAccent}>{daysLeft}</span>
              <span className={styles.subscriptionText}>
                {planT('days-left', {
                  count: daysLeft
                })}
              </span>
            </div>
            {ChangeSlot}
          </div>
          {SignoutSlot}
        </div>
      </Fragment>
    )
  }
)
